import { useDispatch, useSelector } from "react-redux";
import { CONSTANTS } from "../../../common/constants";
import LoadingOverlay from "../../../components/LoadingOverlay/LoadingOverlay";
import Tabs from "../../../components/Tabs/Tabs";
import { TreasuryTransactionCategoryText } from "../../../utils/coimex-utils";
import {
  selectIsGetMmLatestTradesPending,
  selectIsGetMmOrderBookPending,
  selectIsGetTreasuryTransactionsPending,
  selectTreasuryTransactionsSelectedCategory,
} from "../treasury.selectors";
import { treasuryActions } from "../treasury.state";
import {
  toTreasuryTransactionCategoryIndex,
  TreasuryTransactionCategories,
  TreasuryTransactionCategory,
} from "../types/treasury-transactions-category.type";
import CexOrders from "./CexOrders";
import TreasuryInternalTransactions from "./TreasuryInternalTransactions";
import TreasuryInvestPoolTransactions from "./TreasuryInvestPoolTransactions";
import CexLatestTrades from "./CexLatestTrades";

export default function TreasuryTransactions() {
  const isGetTransactionsPending = useSelector(
    selectIsGetTreasuryTransactionsPending
  );
  const isGetMmOrderBookPending = useSelector(selectIsGetMmOrderBookPending);
  const isGetMmLatestTradesPending = useSelector(
    selectIsGetMmLatestTradesPending
  );
  const selectedCategory = useSelector(
    selectTreasuryTransactionsSelectedCategory
  );
  const dispatch = useDispatch();

  const renderTabContent = () => {
    switch (selectedCategory) {
      case TreasuryTransactionCategory.Internal:
        return <TreasuryInternalTransactions />;

      case TreasuryTransactionCategory.InvestPool:
        return <TreasuryInvestPoolTransactions />;

      case TreasuryTransactionCategory.CexOrders:
        return <CexOrders token={CONSTANTS.MarketMaker.Exim} />;

      case TreasuryTransactionCategory.CexLatestTrades:
        return <CexLatestTrades token={CONSTANTS.MarketMaker.Exim} />;
    }
  };

  return (
    <LoadingOverlay
      loading={
        isGetTransactionsPending ||
        isGetMmOrderBookPending ||
        isGetMmLatestTradesPending
      }
    >
      <div className="w-full h-full flex flex-col">
        <div className="flex items-center justify-between">
          <Tabs
            selectedTab={toTreasuryTransactionCategoryIndex(selectedCategory)}
            items={TreasuryTransactionCategories}
            renderItem={(item) => (
              <span>{TreasuryTransactionCategoryText[item]}</span>
            )}
            onTabChange={(tab) =>
              dispatch(
                treasuryActions.changeSelectedTransactionsCategory(
                  TreasuryTransactionCategories[tab]
                )
              )
            }
          />
        </div>
        <div className="flex-1 flex">{renderTabContent()}</div>
      </div>
    </LoadingOverlay>
  );
}
